import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./crew-ok-dialog.component.html')
})
export class CrewOkDialog {
    constructor(public dialogRef: MatDialogRef<CrewOkDialog>) {
        this.title = "";
        this.content = "";
    }

    title: string;

    content: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/crew-ok-dialog.component.ts